import { IAppState } from '../../app.types';
import { generateResourceSelectors } from '../generators/resource.selectors';
import { IMeetingSimple } from '../meeting-simple/meeting-simple.types';
import * as types from './label.types';

const baseSelectors = generateResourceSelectors<types.ILabel>((state) => state.resource.label);

export const labelSelectors = {
  ...baseSelectors,
  selectLabelsByMeetingId: (state: IAppState, meetingId: IMeetingSimple['id']): types.ILabel[] => {
    const allLabels = baseSelectors.selectResourceList(state);
    return allLabels.filter((label) => label.meetingId === meetingId);
  },
};
